import React, {
	Component
} from 'react';
// import { Spring } from 'react-spring';
import { Spring } from 'react-spring/renderprops';

// import styled from 'styled-components';
import { store } from '../stores/mainStore';
// import { ButtonMover } from './Buttons';
import { integration } from '../integration';

export class ModalRewardVideo extends Component {

	  m = window.manager;
	  screenWidth = this.m.config.width;
	  screenHeight = this.m.config.height;

	  rewardModalImage = store.rewardAdModalHearts < 2 ? 'reward_video_message' : 'box_free_hearts_anyway';

	// watchVideo = () => {
	// 	// if (!this.pending){
	// 		// this.pending = true;

	// 		if(store.enableRewardAds) {
	// 			window.manager.playAudio("poopPop");
	// 			integration.postAnalyticsEvent(`reward_watch_ad_post_plus`, `navigation`);
	// 			if(!(window.location.port === '3000' || window.location.hash === '#dev')) {
	// 				store.rewardAdModalHearts = 0;
	// 				window.WrapperApp.postMessage("show-rewardVideo?name=default");
	// 				setTimeout(this.dimPanel, 150);
	// 			} else {
	// 				store.modal = '';
	// 				store.rewardAdModalHearts = 1;
	// 				store.modal = 'rewardVideo';
	// 			}
	// 		}
	// 	// }
	// }
	close = () => {
		integration.postAnalyticsEvent('press_x_close_dialogue_greenplus', "navigaton");

		window.manager.playAudio("poopPop");
		store.modal = '';
	}
	dimPanel() {
		store.modal = 'videoDimPanel';
	}
	goodBye() {
		store.modal = '';
	}
	render() {

		return (
			<div>
				{store.rewardAdModalHearts > 0 && (
					<div ref={ref => {
						if(ref) setTimeout(window.manager.rewardVideoAddHearts, 1000);
						window.manager.playAudio("HeartstoHud_single");
						setTimeout(this.goodBye, 1500);
					}} style={{zIndex: 5000, position:'absolute'}}>
						<Spring
							// from={{ marginLeft: 420, marginTop: 430, opacity: 1}}
							// to={{ marginLeft: 480, marginTop: 0, opacity: 0 }}
							from={{ marginLeft: '45vw', marginTop: '100vw', opacity:1}}
							to={{ marginLeft: '73vw', marginTop: '1vw', opacity: 0.25}}
							delay = {500}
						>
							{props => (
								<div style={props}>
									<img draggable="false"
										style={{width: '11vw', marginTop: '-63'}} alt="heart"
										src="/assets/hud/hud_icon_heart.png"/>
								</div>
							)}
						</Spring>
					</div>
				)}

				{/* <ExitPage>
					<Content>
						<CloseBox>
							<CloseButton src="/assets/btn_close.png" onClick={() => this.close()}/>
							<BoxContent src={`/assets/languages/${store.settings.language}/${this.rewardModalImage}.png`}/>
						</CloseBox>

						{store.rewardAdModalHearts < 2 && (
							<React.Fragment>
								<ButtonMover onClick={() => { this.watchVideo(); }}>
									<img draggable="false"
									style={{width: '34vw', marginLeft: '2vw'}} alt="watch video game" src={`/assets/languages/${store.settings.language}/btn_watch.png`}/>
								</ButtonMover>
							</React.Fragment>
						)}
					</Content>
				</ExitPage> */}
			</div>
		);
	}
}
